import type { Locale } from '@mfw/translations';

import type {
  UiUpdateOrganizationMemberProfile,
  ApiOrganizationMemberProfile,
} from '../schemas/organizationMemberProfile.schema';
import type { BaseApiResponse } from './types/api.types';

import {
  mapUpdateOrganizationMemberProfileToApi,
  mapOrganizationMemberProfileFromApi,
} from './mappers/organizationMemberProfile.mappers';
import { get, put } from './axios';

export async function fetchMyOrganizationMemberProfile({
  locale,
  organizationId,
}: {
  organizationId: string;
  locale: Locale;
}) {
  const response = await get<BaseApiResponse<ApiOrganizationMemberProfile>>(
    `/v2/organizations/${organizationId}/members/me/profile`,
  );
  return mapOrganizationMemberProfileFromApi(response?.data, locale);
}

export async function fetchOrganizationMemberProfile({
  locale,
  organizationId,
  userId,
}: {
  organizationId: string;
  locale: Locale;
  userId: string;
}) {
  const response = await get<BaseApiResponse<ApiOrganizationMemberProfile>>(
    `/v2/organizations/${organizationId}/members/${userId}/profile`,
  );
  return mapOrganizationMemberProfileFromApi(response?.data, locale);
}

export async function fetchOrganizationMemberProfileTemplate({
  locale,
}: {
  locale: Locale;
}) {
  const response = await get<
    BaseApiResponse<ApiOrganizationMemberProfile | null>
  >(`/v2/auth/me/member-profile-template`);
  return mapOrganizationMemberProfileFromApi(response?.data, locale);
}

export async function updateMyOrganizationMemberProfile({
  locale,
  organizationId,
  values,
}: {
  values: UiUpdateOrganizationMemberProfile;
  organizationId: string;
  locale: Locale;
}) {
  const response = await put<ApiOrganizationMemberProfile>(
    `/v2/organizations/${organizationId}/members/me/profile`,
    mapUpdateOrganizationMemberProfileToApi(values),
  );
  return mapOrganizationMemberProfileFromApi(response?.data, locale);
}
